<template>
    <div class="vue-teaser-slider" :class="isSmall ? 'is-small' : 'is-large'">
        <hooper ref="teaserCarousel" :settings="hooperSettings">
            <slot></slot>
        </hooper>

        <ef2-slider-navigation
            @slider-next="handleSliderNext"
            @slider-previous="handleSliderPrevious"
        ></ef2-slider-navigation>
    </div>
</template>

<script>
export default {
    name: "NeartoSlider",

    props: {
        isSmall: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            extraClass: '',
            hooperSettings: {
                wheelControl: false,
                infiniteScroll: false,
                mouseDrag: false,
                itemsToSlide: 1,
                breakpoints: {
                    1920: {
                        itemsToShow: 3
                    },
                    1200: {
                        itemsToShow: 2.5
                    },
                    768: {
                        itemsToShow: 2,
                        itemsToSlide: 1
                    },
                    0: {
                        itemsToShow: 1.1,
                        itemsToSlide: 1
                    }
                }
            },
        }
    },

    created() {
        if (this.isSmall) {
            this.hooperSettings.breakpoints = {
                1440: {
                    itemsToShow: 4
                },
                1366: {
                    itemsToShow: 4
                },
                768: {
                    itemsToShow: 3
                },
                0: {
                    itemsToShow: 1.8
                }
            }
        }
    },

    methods: {
        handleSliderNext() {
            this.$refs.teaserCarousel.slideNext();
        },

        handleSliderPrevious() {
            this.$refs.teaserCarousel.slidePrev();
        }
    }
}
</script>
